import React from 'react';
import { Box, Typography } from '@mui/material';
import { useThemeContext } from '../contexts/BaseThemeContextProvider';
import AppointmentsList from './AppointmentsList';

const AppointmentsPage = () => {
  const { theme } = useThemeContext();
  const pageBg = theme.layout.defaults.backgroundColor;

  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: '1200px',
        margin: '0 auto',
        backgroundColor: pageBg,
        borderRadius: '20px',
        padding: { xs: '20px', sm: '40px' },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          padding: { sm: '5px 8px', xs: '10px 4px' },
          alignItems: 'center',
          width: '100%',
          marginBottom: { xs: '10px', sm: '18px' },
        }}
      >
        <Typography
          variant="h4"
          sx={{
            fontWeight: 600,
            color: theme.custom.pages.frost.authHome.typography.body1.color,
          }}
        >
          My Appointments
        </Typography>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
        }}
      >
        <AppointmentsList />
      </Box>
    </Box>
  );
};

export default AppointmentsPage;
